import { Outlet, createFileRoute } from '@tanstack/react-router'

import StudentAppPagePadding from '@/app/student/StudentAppPagePadding'
import { LoadingIndicator } from '@/core/components/LoadingIndicator'

export const Route = createFileRoute('/_learning/discover/course-generic')({
  component: RouteComponent,
  pendingComponent: () => <LoadingIndicator />,
})

function RouteComponent() {
  return (
    <StudentAppPagePadding>
      <Outlet />
    </StudentAppPagePadding>
  )
}
